import { render } from "./PlaylistCreatorComponent.vue?vue&type=template&id=4e8aa808&scoped=true&ts=true"
import script from "./PlaylistCreatorComponent.vue?vue&type=script&lang=ts"
export * from "./PlaylistCreatorComponent.vue?vue&type=script&lang=ts"

import "./PlaylistCreatorComponent.vue?vue&type=style&index=0&id=4e8aa808&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8aa808"]])

export default __exports__